import type {FacebookLikePageVerificationAttemptData} from '@cohort/shared/apps/facebook/triggers/likePage';
import {Trans} from 'react-i18next';

const FacebookLikePageTriggerStepCompletionTitleComponent: React.FC<{
  data: FacebookLikePageVerificationAttemptData;
}> = ({data}) => {
  return (
    <Trans
      i18nKey="triggers.like-page.stepCompletionTitleComponent.success"
      ns="app-facebook"
      values={{username: data.username}}
    />
  );
};

export default FacebookLikePageTriggerStepCompletionTitleComponent;
